// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import { useMutation } from '@ion/api';
import permissions from '@ion/api/Apollo/permissions';

import { mutation, buildVariables } from './bulk-insert-pipelines-mutation-builder';

export default function useBulkInsertPipelines(options = {}) {
  const [executeMutation, response] = useMutation(mutation, {
    context: { permission: permissions.createPipeline },
    refetchQueries: [],
    awaitRefetchQueries: false,
    ...options,
  });

  const bulkInsertPipelines = pipelines => {
    return executeMutation({
      variables: buildVariables(pipelines),
    });
  };

  return [bulkInsertPipelines, response];
}
